import Component from '../app/component'
import barba from '@barba/core'

export default class FooterComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {
      style: null
    }
  }

  init () {

    let langs = document.querySelectorAll('.wpml-ls-native');
    langs.forEach(l => {
      l.parentNode.classList.add('no-barba')
      l.parentNode.setAttribute('data-barba-prevent', 'self')
      l.innerHTML = l.textContent.substring(0,2);
    })
    barba.hooks.afterLeave(data => {
      // change top style
      this.data.style = ['home'].includes(data.next.namespace) ? 'alt' : 'default'

      if (data.next.namespace === 'contacts') {
        this.refs.title.classList.add('cm-footer-title--hidden')
      } else {
        this.refs.title.classList.remove('cm-footer-title--hidden')
      }
    })

    if (this.refs.title) {
      this.refs.title.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('contactformoverlay.toggle'))
      })
    }
  }

  watchStyle (value) {
    if (!['alt', 'default'].includes(value)) {
      return
    }



    if (value === 'default') {
      this.el.classList.remove('cm-footer--alt')
      this.el.classList.add('cm-footer--default')
      if (this.refs.contactsLink) {
        this.refs.contactsLink.classList.remove('ui-button--inverse')
      }
    } else {
      this.el.classList.remove('cm-footer--default')
      this.el.classList.add('cm-footer--alt')
      if (this.refs.contactsLink) {
        this.refs.contactsLink.classList.add('ui-button--inverse')
      }
    }
  }
}
